import { useSuspenseQuery } from '@tanstack/react-query'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { RisksHttpClient, RiskResponse } from '@omnea-app/risks/risksHttpClient'

export type ListRiskAttributesResponse = RiskResponse<'/attributes', 'get'>

export const listRiskAttributesQueryKey = 'listRiskAttributes'

export const useListRiskAttributes = () => {
  const { getToken } = useAuthenticatedUser()

  return useSuspenseQuery<ListRiskAttributesResponse['data']>({
    queryKey: [listRiskAttributesQueryKey],
    queryFn: async () => {
      const apiClient = new RisksHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/attributes')
      throwIfApiError(error)
      return data
    },
  })
}
